<template>
  <div class="addPhoneBox">
    <!-- <div>phoneData:{{ phoneData }}</div> -->
    <van-field
      v-for="(item, i) in phoneData"
      v-model="item.mobile"
      :key="i + item.mobile"
      label="手机号"
      @click-right-icon="clickRightIcon(i, item)"
      right-icon="close"
      readonly
      placeholder=""
    />
    <!--
      添加手机号功能已下线（验证码短信停发），故隐藏入口，enableAddPhone=true；
      仅保留上方已绑手机号的展示与解绑（右侧 x 图标），两者不依赖短信验证，仍允许用户看到添加过的手机号，也允许用户解绑添加过的手机号
    -->
    <van-button v-if="enableAddPhone" class="addPhoneBtn" color="#3088c5" @click="addPhoneBtnEvent" type="primary" size="mini">添加手机号</van-button>
    <van-dialog
      v-model:show="isShowDialog"
      :title="dialogConfig.title"
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <!-- <div>isShowCountDown--{{ isShowCountDown }}</div>
        <div>residueTime--{{ residueTime }}</div> -->
        <van-field v-model="dialogData.mobile" :error-message="errorMessage.mobile" required type="tel" clearable label="手机号" placeholder="请输入手机号" />
        <van-field v-model="dialogData.code" :error-message="errorMessage.code" required type="digit" clearable label="短信验证码" placeholder="请输入验证码">
          <template #button>
            <van-button
              :loading="loadCode"
              loading-type="spinner"
              loading-text="获取中"
              :disabled="codeBtnDisableBool"
              size="mini"
              type="primary"
              @click="getVerificationCodeFn"
            >
              <span v-if="isShowCountDown">重试(<van-count-down :time="residueTime" format="ss" @finish="resetCodeStatus" />S)</span>
              <span v-else>发送验证码</span>
            </van-button>
          </template>
        </van-field>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from 'vue'
import { showToast } from '@/util/couponCollection'
import useAddPhone from '@/hooks/directSales/useAddPhone'
import _ from 'lodash'

// 「添加手机号」入口开关。因验证码短信已下线，置为 false 隐藏入口，恢复时改为 true，并同步从后端 SMS_DISABLED_TEMPLATES 移除 SMS_VERIFY_CODE。
const ENABLE_ADD_PHONE = false

export default {
  props: {
    data: {
      type: [Array],
      default: () => []
    }
  },
  components: {},
  emits: ['update'],
  setup(props, { emit }) {
    const {
      isShowDialog,
      isShowCountDown,
      dialogConfig,
      dialogData,
      errorMessage,
      residueTime,
      addPhoneBtnEvent,
      beforeCloseDialog,
      getVerificationCodeFn,
      loadCode,
      codeBtnDisableBool,
      resetCodeStatus,
      hasSuccess,
      successData
    } = useAddPhone()
    let { data } = toRefs(props)
    const state = reactive({
      data
    })
    const phoneData = computed(() => {
      return state.data.filter(item => item.delStatusFlag !== 1)
    })
    const updatePhoneData = data => {
      emit('update', data)
    }
    const clickRightIcon = (i, data) => {
      //console.log('clickRightIcon', i, data)
      let dataRes = []
      if (data.id) {
        dataRes = state.data.map(item => ({
          ...item,
          delStatusFlag: item.id === data.id ? 1 : item.delStatusFlag
        }))
      } else {
        let index = state.data.findIndex(item => !data.id && item.mobile === data.mobile)
        dataRes = _.cloneDeep(state.data)
        dataRes.splice(index, 1)
      }
      updatePhoneData(dataRes)
    }

    watch(
      () => hasSuccess.value,
      v => {
        //console.log('hasSuccess-v', v, successData.value)
        if (v && successData.value?.mobile) {
          let dataRes = [...state.data, { id: '', mobile: successData.value?.mobile, delStatusFlag: 0, new: true }]
          // updatePhoneData(_.uniqBy(dataRes, 'mobile'))
          updatePhoneData(dataRes)
        }
      }
    )

    return {
      ...toRefs(state),
      enableAddPhone: ENABLE_ADD_PHONE,
      phoneData,
      isShowDialog,
      isShowCountDown,
      dialogConfig,
      dialogData,
      errorMessage,
      residueTime,
      clickRightIcon,
      addPhoneBtnEvent,
      beforeCloseDialog,
      getVerificationCodeFn,
      loadCode,
      codeBtnDisableBool,
      resetCodeStatus
    }
  }
}
</script>
<style lang="scss" scoped>
.addPhoneBox {
  text-align: right;
  background: #fff;
  .addPhoneBtn {
    margin: 10px;
  }
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 20px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    // border: 1px solid red;
  }

  .van-count-down {
    display: inline-block;
    font-size: 12px;
    color: #666;
    // color: red;
  }
}
</style>
